<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import Cycle from '@/dc-it/models/Cycle'

export default {
  name: 'UsersView',
  components: { TableComponent },
  data() {
    return {
      model: Cycle,
    }
  },
}
</script>

<style scoped>

</style>
